// extracted by mini-css-extract-plugin
export default {"container":"style_container__9dTwO","background":"style_background__VVbLw"};